import React, { FC, JSX } from 'react';

interface MobileContainerProps {
    children: string | JSX.Element;
}

export const MobileContainer: FC<MobileContainerProps> = ({ children }) => {
    return (
        <div className="d-flex" style={{ height: '100%', width: '100vw', padding: '30px' }} data-testid="mobile-container">
            {children}
        </div>
    );
};
